import React, { useState } from 'react';
import { handleADA } from '../../../utility/utils';

type Props = {
  label: string,
  onClick: () => void
};

const FilterValue = ({label, onClick}:Props) => {
  const [active, setActive] = useState(false);
  const handleTap = () => {
    setActive(!active);
    onClick();
  };
  return (
    <a
      className={`filter-value ${active ? 'active' : ''}`}
      onKeyPress={(e) => handleADA(e, 'button', () => handleTap())}
      tabIndex={0}
      role="button"
      onClick={() => handleTap()}>
      <p>{label}</p>
    </a>
  );
}

export default FilterValue;
